import { FC, useState } from 'react';
import dayjs from 'dayjs';
import { Button, Box, Paper, Divider, Container } from '@mui/material';
import _isDate from 'lodash/isDate';
import _isString from 'lodash/isString';

// local
import { defs } from "@common/const_defs";
import { ActionCB } from '@common/type_defs';
import { ContactUsData, newContactUsData } from "@data/contact-us";
import { post_contact_us_mail } from '@api/misc';
import ContactUsFromPanel from './components/ContactInputPanel';

export const formatDate = (dt: Date | string | undefined): string => {
  let str = '';
  if (_isDate(dt)) {
    str = dayjs(dt).format('YYYY-MM-DD');
    // const m = `0${dt.getMonth() + 1}`.slice(-2);
    // const d = `0${dt.getDate()}`.slice(-2);
    // str = `${dt.getFullYear()}-${m}-${d}`;
  } else if (_isString(dt)) {
    str = dt;
  }
  return str;
};


type ContactPanelProps = {
  flag: string;
  onAction: ActionCB;
}
const ContactPanel: FC<ContactPanelProps> = ({ flag, onAction }) => {
  const [data, setData] = useState<ContactUsData>(newContactUsData());

  const handleAction = async (act: string, vd: ContactUsData) => {
    if (act === defs.kAct_ExecContactUsSend) {
      if (onAction) {
        onAction(defs.kAct_ExecContactUsSend, vd);
      } else {
        const rst = await post_contact_us_mail(vd);
        if (rst) {
          alert(`ご問い合わせ、ありがとうございます。`);
          window.location.href = window.location.origin + "/";
        }
      }
    }
  }

  return (
    <Box component="div" sx={{ background: "url(./assets/images/img-bkgd.jpg) center center/cover no-repeat", }}>
      <Container sx={{ mt: 3, pt: 9, width: "100%", maxWidth: "720px !important", }}>
        <Paper>
          <ContactUsFromPanel data={data} onAction={handleAction} />
          <Divider />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button variant="contained" type="submit" form="form-contact-us" sx={{ m: 2 }}>
              送信
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default ContactPanel;
export { ContactPanel };